import CandidateStatusCard from "./candidateStatusCard";
export default CandidateStatusCard;